import AboutSection from "../../components/about-section/about-section.component";
import AutoSlider from "../../components/auto-slider/auto-slider.component";
import BenefitSection from "../../components/benefit-section/benefit-section.component";
import CategorySection from "../../components/category-section/category-section.component";
import MiniShopSection from "../../components/mini-shop-section/mini-shop-section.component";
import "./home.styles.css";
import DropSection from "../../components/drop-section/drop-section.components";
import { useState } from "react"; // اضافه کردن useState
import HeroSection from "../../components/hero-section/HeroSection.component";

const Home = () => {
  const [language, setLanguage] = useState("FA"); // مدیریت زبان

  return (
    <div>
      {/* <AutoSlider /> */}
      <HeroSection />
      {/* <DropSection /> */}
      <AboutSection language={language} />
      <MiniShopSection />
      {/* <CategorySection /> */}
      <BenefitSection />
    </div>
  );
};

export default Home;
